import { HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr'
import { get } from './api'

declare global {
  interface Window {
    testSignalRHandler?: (type: string, message: unknown) => Promise<void>
  }
}

export const defaultSignalrUrl = 'https://master-qa4cfd17d7.service.signalr.net'

export type SignalrHandlers = Record<string, (message: never) => unknown>

export async function connectSignalr(signalrUrl: string, handlers: SignalrHandlers) {
  const handleMessage = async (type: string, message: unknown) => {
    console.log('signalr message', type, message)
    const handler = handlers[type] as ((message: unknown) => unknown) | undefined
    await handler?.(message)
  }

  if (navigator.webdriver) {
    window.testSignalRHandler = handleMessage
    return
  }

  const connection = new HubConnectionBuilder()
    .withUrl(`${signalrUrl}/client/?hub=ossovr`, {
      accessTokenFactory: () => getAccessToken()
    })
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Information)
    .build()

  connection.on('loop', handleMessage)
  connection.on('message', () => {}) //no-op to stop warning for legacy signalr messagess
  connection.onclose(() => {
    console.log('signalr connection closed, restarting')
    setTimeout(async () => {
      if (connection.state !== HubConnectionState.Disconnected) {
        return
      }
      await connection.start()
    }, 5000)
  })
  await connection.start()
}

async function getAccessToken() {
  const response = await get<{ token: string }>('signalr-token')
  if (!response || !response.body) {
    throw new Error('failed to get signalr token')
  }
  return response.body.token
}
